import React, { useMemo, useState } from "react";
import styled from "styled-components";
import VerticalTabs from "../../ProfileCard/Contract/VerticalTabs";
import PersonalInformation from "../../ProfileCard/Contract/screen/PersonalInformation";
import BankInformation from "../../ProfileCard/Contract/screen/BankInformation";
import Confirm from "../../../Profile/ProfileCard/Contract/screen/Confirm";
import ContractType from "../../ProfileCard/Contract/screen/ContractType";
import assets from "../../../../../assets/assets";
import { useContract } from "../../../../../provider/ContractProvider";
import { IconController } from "../../../../Scripts/ImgController";
import TermsConditional from "./screen/Terms&Condition";

const Wrapper = styled.div`
  background: linear-gradient(111.08deg, #111827 0%, #0061ff 100%);
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: auto;
  scrollbar-width: none;

  .border-CK {
    border: 1px solid #d1d5db;
    border-radius: 12px;
    background: white;
    max-width: 950px;
    width: 100%;
    z-index: 3;
  }

  .paragraph-CK {
    color: #344054;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    flex-basis: 30%;
  }
`;

const Agreement = () => {
  const steps = [
    PersonalInformation,
    TermsConditional,
    BankInformation,
    ContractType,
    Confirm,
  ];
  const { step } = useContract();
  const [values, setValues] = useState({});

  const Step = useMemo(() => {
    return steps[step - 1];
  }, [step]);

  return (
    <Wrapper>
      {/* <Licensemodal /> */}
      <div className="w-full h-full flex flex-col justify-center items-center relative z-102">
        <div className="border-CK relative overflow-hidden">
          {/* Header */}
          <div className="w-full border-b border-[#E4E7EC] z-50">
            <div className="flex p-6">
              <IconController
                src={assets.svg.mmusicLogoBorderedBlue}
                alt="Mmusic Logo"
                className="h-12 w-12"
              />
              <div className="ml-3 w-full">
                <h3 className="font-semibold text-lg leading-7">
                  {Step === ContractType ? "Mmusic Distribution" : "Mmusic LLC"}
                </h3>
                <h5 className="text-sm font-normal text-[#475467]">
                  {Step === ContractType
                    ? "Гэрээ байгуулах, уран бүтээлч болох"
                    : "Гэрээ байгуулах, артист болох"}
                </h5>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="flex">
            <div className="basis-1/5 flex justify-center items-center p-2">
              <VerticalTabs activeStep={step} />
            </div>

            <div className="basis-4/5 h-[540px] overflow-y-scroll">
              <div className="w-full h-full">
                <Step values={values} setValues={setValues} />
              </div>
            </div>
          </div>

          {/* Confirm Footer */}
          <div className="py-12.5"></div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Agreement;
